import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useMemo,
} from "react";
import { safeReadJsonFromLocalStorage } from "../utils/storage";
import { getCargoTanksForActiveVessel } from "../application/projections/tanks/getCargoTanksForActiveVessel";

const ShipSettingsContext = createContext();

export const ShipSettingsProvider = ({ children }) => {
  const [shipData, setShipData] = useState(null);

  // Ladda från localStorage vid start för omedelbar tillgång offline
  useEffect(() => {
    const savedShip = safeReadJsonFromLocalStorage("activeShipData");
    if (savedShip) {
      setShipData(savedShip);
    }
  }, []);

  // Denna anropas när skeppet hämtats från Firestore (vid login/sync)
  const updateShipData = (newData) => {
    setShipData(newData);
    localStorage.setItem("activeShipData", JSON.stringify(newData));
  };

  // Dynamisk mappning av tankar baserat på den nya strukturen
  const tanks = useMemo(() => {
    return getCargoTanksForActiveVessel(shipData).filter(
      (tank) => !tank.name.toLowerCase().includes("drain")
    );
  }, [shipData]);

  // Vi kan även lägga till en memo för ballast eller teknisk info om det behövs
  const vesselInfo = useMemo(
    () => shipData?.configuration?.identifiers || {},
    [shipData]
  );

  return (
    <ShipSettingsContext.Provider
      value={{
        shipData, // Hela super-objektet
        vesselInfo, // Snabbåtkomst till CallSign, IMO etc.
        updateShipData,
        tanks, // Din sorterade tanklista
        loading: !shipData,
      }}
    >
      {children}
    </ShipSettingsContext.Provider>
  );
};

export const useShipSettings = () => {
  const context = useContext(ShipSettingsContext);
  if (!context)
    throw new Error("useShipSettings must be used within ShipSettingsProvider");
  return context;
};
